// login page here
import React, { useState } from "react";
import { useStyles } from '../../assets/styles.js'
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Bharat_Darshan_Logo from '../../assets/images/Logo/Bharat-Darshan-Logo.png'
import "./Login.css";

import { useDispatch, useSelector } from "react-redux";
import * as AuthAction from "../../redux/actions/authAction.js";

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loginData, setLoginData] = useState({ username: '', userType: '', password: '' });
    const [loginDataError, setLoginDataError] = useState({ username: '', userType: '', password: '' });

    //* Handle Input Field : Error
    const handleInputError = (input, value) => {
        setLoginDataError((prev) => ({ ...prev, [input]: value }));
    };

    //* Handle Input Field : Data
    const handleInputField = (e) => {
        setLoginData({ ...loginData, [e.target.name]: e.target.value });
    };

    const validation = () => {
        var valid = true
        if (loginData?.username.length === 0) {
            handleInputError("username", "Please enter username/email");
            valid = false
        }
        if (loginData?.password.length === 0) {
            handleInputError("password", "Please enter password");
            valid = false
        }
        if (!loginData?.userType) {
            handleInputError("userType", "Please select usertype");
            valid = false
        }
        return valid
    }

    const handleLogin = async (event) => {
        event.preventDefault();
        if (validation()) {
            const { username, password, userType } = loginData;
            localStorage.setItem('userType', userType);
            const payload = {
                data: { username, password, userType },
                onComplete: () => navigate("/")
            }

            //! Dispatching API for Admin Login 
            dispatch(AuthAction.adminLogin(payload));
        }
    };

    return (
        <>
            <section className="login-section">
                <article>
                    <main >
                        <div className="left-section">
                            <div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                                    <img src={Bharat_Darshan_Logo} style={{ width: '150px', height: '150px' }} />
                                    <div style={{ fontSize: '2rem', fontFamily: 'Philosopher', fontWeight: "600" }} >Bharat Darshan</div>
                                </div>
                            </div>
                        </div>

                        <div className="right-section">
                            <div style={{ maxWidth: "30rem", backgroundColor: "" }}>
                                <Grid container spacing={3}>
                                    <Grid item lg={12} sm={12} md={12} xs={12} >
                                        <div style={{ fontSize: '2rem', fontFamily: 'Philosopher', fontWeight: "600", marginBottom: "-10px" }} >Login</div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    style={{ backgroundColor: "#fff" }}
                                                    label="Username/Email" variant='outlined' fullWidth
                                                    name='username'
                                                    value={loginData?.username}
                                                    onChange={handleInputField}
                                                    onFocus={() => handleInputError("username", null)}
                                                />
                                                {loginDataError.username ? <div style={{ color: "red", fontSize: "13px" }}>{loginDataError?.username}</div> : ""}
                                            </Grid>

                                            <Grid item xs={12} >
                                                <FormControl fullWidth>
                                                    <InputLabel id="select-label">User Type</InputLabel>
                                                    <Select
                                                        style={{ backgroundColor: "#fff" }}
                                                        label="User Type" variant="outlined" fullWidth
                                                        name='userType'
                                                        value={loginData?.userType}
                                                        onChange={handleInputField}
                                                        onFocus={() => handleInputError("userType", null)}
                                                    >
                                                        <MenuItem disabled>---User Type---</MenuItem>
                                                        <MenuItem value="admin">Admin</MenuItem>
                                                        <MenuItem value="subadmin">Sub Admin</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                {loginDataError.userType ? <div style={{ color: "red", fontSize: "13px" }}>{loginDataError?.userType}</div> : ""}
                                            </Grid>

                                            <Grid item xs={12}>
                                                <TextField
                                                    style={{ backgroundColor: "#fff" }}
                                                    label="Password" variant='outlined' fullWidth
                                                    name='password'
                                                    value={loginData?.password}
                                                    onChange={handleInputField}
                                                    onFocus={() => handleInputError("password", null)}
                                                />
                                                {loginDataError.password ? <div style={{ color: "red", fontSize: "13px" }}>{loginDataError?.password}</div> : ""}
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item lg={5} sm={5} md={5} xs={5} >
                                        <div className='loginButton' onClick={handleLogin}>
                                            Login
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </main>
                </article>
            </section>
        </>
    )
}
export default Login;


